import React, { useState } from 'react';
import { Plus, X, Briefcase, FileText } from 'lucide-react';

const MobileFAB = ({ onAddJob, onAddContract, onAddCustomer, actions: customActions }) => {
  const [open, setOpen] = useState(false);

  // Build actions from either custom array or legacy props
  const actions = customActions || [];
  if (!customActions) {
    if (onAddJob) actions.push({ label: 'Add Job', icon: Briefcase, onClick: onAddJob });
    if (onAddContract) actions.push({ label: 'Add Contract', icon: FileText, onClick: onAddContract });
    if (onAddCustomer) actions.push({ label: 'Add Customer', icon: Plus, onClick: onAddCustomer });
  }

  if (actions.length === 0) return null;

  // Single action — just trigger directly
  const handleClick = () => {
    if (actions.length === 1) {
      actions[0].onClick();
      return;
    }
    setOpen(!open);
  };

  return (
    <div className="md:hidden fixed bottom-6 right-6 z-40">
      {/* Context menu */}
      {open && actions.length > 1 && (
        <>
          <div className="fixed inset-0" onClick={() => setOpen(false)} />
          <div className="absolute bottom-16 right-0 bg-white rounded-lg shadow-lg border border-gray-200 py-1 min-w-[160px]">
            {actions.map((action) => (
              <button
                key={action.label}
                onClick={() => { setOpen(false); action.onClick(); }}
                className={`flex items-center gap-3 w-full px-4 py-2.5 text-sm hover:bg-gray-50 transition-colors ${action.danger ? 'text-red-600' : 'text-gray-700'}`}
              >
                <action.icon size={16} className={action.danger ? 'text-red-500' : 'text-pest-blue'} />
                <span>{action.label}</span>
              </button>
            ))}
          </div>
        </>
      )}

      {/* FAB button */}
      <button
        onClick={handleClick}
        className="w-14 h-14 rounded-full bg-pest-blue text-white shadow-lg flex items-center justify-center hover:bg-blue-600 transition-all active:scale-95"
      >
        {open ? <X size={24} /> : <Plus size={24} />}
      </button>
    </div>
  );
};

export default MobileFAB;
